import { createGlobalStyle } from 'styled-components';

//TODO: Remove any after styles-components updates
export const GlobalStyles: any = createGlobalStyle`
  html {
    overscroll-behavior: none;
  }

  /* The typography reset forces a permanent scrollbar on html. Back to visible, the page scrolls only when it must,
     and the scroll lock of the antd modals, which sets overflow on body, reaches the viewport. */
  :root {
    overflow-y: visible;
  }

  html, body {
    margin: 0;
    background-color: ${({ theme }) => theme.colors.neutral.background};

    .sensei-ui-tooltip-content a {
      color: ${({ theme }) => theme.colors.neutral.palette100};
    }

    img {
      margin: initial;
    }

    *::-webkit-scrollbar {
      width: 5px;
    }

    *::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => theme.colors.neutral.palette500};
      border-radius: ${({ theme }) => theme.radii.lg}px;
    }

  }

  // TODO: Fix DatePicker styles in design-system
  table.sensei-ui-picker-content th {
    padding: 0;
  }

  // TODO(Sensei-UI): Add Tables styles to design-system

  table tbody td.sensei-ui-table-cell-fix-left,
  table tbody td.sensei-ui-table-cell-fix-right {
    background-color: ${({ theme }) => theme.colors.neutral.palette700} !important;
  }

  .sensei-ui-table-wrapper .sensei-ui-table,
  .sensei-ui-table-wrapper .sensei-ui-table-sticky-holder,
  .sensei-ui-table-wrapper .sensei-ui-table table thead td,
  .sensei-ui-table-wrapper .sensei-ui-table table thead th,
  .sensei-ui-table-wrapper .sensei-ui-table table thead th:before {
    background-color: transparent !important;
    border: 0;
  }


  // TODO: Remove after fix typography css reset
  .sensei-ui-picker-content th, .sensei-ui-picker-content td {
    text-align: center;
  }

  // TODO: Update Table styles in design-system

  .sensei-ui-table-cell.sensei-ui-table-cell-scrollbar:not([rowspan]) {
    background-color: ${({ theme }) => theme.colors.neutral.background};
    border: none;
    box-shadow: none;
  }
`;
